export default {
  BOX: 'box'
}



// WEBPACK FOOTER //
// ./src/modules/Sorting/Areas/ItemTypes.js